class SiteInvert {
    constructor(parent, data) {
        window.addEventListener('scroll', () => {
            this.checkNavbarDistance();
        });
        window.addEventListener('resize', () => {
            this.checkNavbarDistance();
        });
        this.checkNavbarDistance();
    }

    checkNavbarDistance() {
        if (document.querySelector('[data-invert-desactive]')) {
            return;
        }

        const navbar = document.querySelector('[data-invert-anchor]');
        const footer = document.querySelector('[data-invert-target]');
        const body = document.body;

        const navbarRect = navbar.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        const halfViewportHeight = window.innerHeight / 2;
        const distance = footerRect.top - navbarRect.bottom;

        if (distance < halfViewportHeight) {
            body.classList.add('invert');
        } else {
            body.classList.remove('invert');
        }
    }
}

export default SiteInvert